import AddCircle from '@mui/icons-material/AddCircle'
import Forward from '@mui/icons-material/Forward'
import { Box, Button, Stack, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const TranslationTester = () => {
  const [namespaces, setNamespaces] = useState<string[]>([''])
  return (
    <Stack alignItems="flex-start">
      {namespaces.map(k => (
        <TranslationNamespacer key={k} />
      ))}
      <Button startIcon={<AddCircle />} onClick={() => setNamespaces(a => [...a, ''])}>
        Add namespace
      </Button>
    </Stack>
  )
}

const TranslationNamespacer = () => {
  const [namespace, setNamespace] = useState('')
  const [keys, setKeys] = useState<string[]>([''])

  return (
    <Stack>
      <TextField label="Namespace" value={namespace} onChange={e => setNamespace(e.target.value)} />
      <Stack sx={{ ml: 2, mt: 1 }} alignItems="flex-start">
        {keys.map(k => (
          <TranslationKeyer key={k} namespace={namespace} />
        ))}
        <Button startIcon={<AddCircle />} onClick={() => setKeys(a => [...a, ''])}>
          Add key
        </Button>
      </Stack>
    </Stack>
  )
}

const TranslationKeyer = ({ namespace }: { namespace: string }) => {
  const { t } = useTranslation(namespace)
  const [key, setKey] = useState('')
  return (
    <Stack direction="row" spacing={1} sx={{ mt: 1 }} justifyContent="center" alignItems="center">
      <TextField
        value={key}
        label="Key"
        onChange={e => setKey(e.target.value)}
        sx={{ width: 140 }}
      />
      <Forward />
      <Box
        sx={{
          width: 140,
          borderRadius: 1,
          border: '1px dashed rgba(0, 0, 0, 0.87)',
          pl: 1,
          py: 1,
          minHeight: 40,
        }}
        justifyContent="center"
      >
        <Typography>{t(key)}</Typography>
      </Box>
    </Stack>
  )
}
